import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import {Button, ButtonGroup} from "reactstrap";
import TextLabel from "../../../controls/TextLabel.mjs";
import "./MessaggiAreaHeader.css";
import UserIcon from "../../../media/assets/UserIcon.mjs";
import AppEditIcon from "../../../media/assets/AppEditIcon.mjs";

const prefix = "MessaggiAreaHeader";

const MessaggiAreaHeader = class extends Component {
	constructor(props) {
		super(props);
		this.state = {}
	}
	render() {
		return (
			<div className={prefix+' list'}>
				<div>
						<span>
							<TextLabel value={"Ads"} />
						</span>
					<strong>
						{ this.props.tot || '' }
					</strong>
				</div>
				<ButtonGroup
					className="btn-icon"
				>
					{ this.props.user ? (
						<Button
							color={"primary"}
							onClick={ ()=> {
								Glob.trigger('MessaggeEdit', true );
							}}
						>
							<b>
								<TextLabel value={this.props.axle === 'offro' ? 'Offering' : 'Wanted'} />…
							</b>
							<i>
								<AppEditIcon />
							</i>
						</Button>
					) : (
						<Button
							color={"success"}
							onClick={ ()=> {
								Glob.setCurrentPageParam('pane', 'user' );
							}}
						>
							<b>
								<TextLabel value={'Login'} />
							</b>
							<i>
								<UserIcon />
							</i>
						</Button>
					) }
				</ButtonGroup>
			</div>
		)
	}
}

export default MessaggiAreaHeader;